import "core-js/modules/es6.object.freeze";
import EASING from './easing';
var DEFAULT_TIME = 300; // ms

var SLOW_TIME = 500;
export var transitions = Object.freeze({
  "default": "all " + DEFAULT_TIME + "ms " + EASING.EXPO,
  slow: "all " + SLOW_TIME + "ms " + EASING.EXPO,
  easing: {
    "default": EASING.EXPO
  },
  timeEasing: {
    "default": DEFAULT_TIME + "ms " + EASING.EXPO
  }
});
export default transitions;